import {createSlice} from "@reduxjs/toolkit";

const initialRepriceActivitiesState = {
    listLoading: false,
    actionsLoading: false,
    total_count: 0,
    entities: null,
    virtualIngestions: null,
    savedSearches: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const repriceactivitiesSlice = createSlice({
    name: "repriceactivities",
    initialState: initialRepriceActivitiesState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        // findRepriceActivities
        repriceactivitiesFetched: (state, action) => {
            const {total_count, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.total_count = total_count;
        }
    }
});
